module.exports = __webpack_public_path__ + "e70e0a04f9fc0846fd02d4f2e497d3ac.jpg";